export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="relative bg-gradient-to-br from-foreground-900 to-foreground-800 rounded-3xl p-8 md:p-14 text-center overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20with%20play%20buttons%20and%20wave%20shapes%2C%20dark%20background%2C%20subtle%20texture%2C%20minimalist%20tech%20pattern%2C%20monochrome%20design&width=1200&height=600&seq=cta-bg-pattern&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          <div className="relative z-10">
            <h2 className="text-2xl md:text-4xl font-heading text-white mb-4">
              准备好了吗？立即加入黄瓜视频！
            </h2>
            <p className="text-white/60 text-sm md:text-base max-w-lg mx-auto mb-8">
              下载黄瓜视频APP，海量高清短视频等你来刷。支持iOS和Android，完全免费！
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="#"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white rounded-full font-medium text-base hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-apple-line text-lg"></i>
                App Store 下载
              </a>
              <a
                href="#"
                className="w-full sm:w-auto px-8 py-3.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white rounded-full font-medium text-base hover:bg-white/20 transition-all duration-300 whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </a>
            </div>
            <p className="mt-6 text-xs text-white/30">
              黄瓜视频最新版本已发布，支持高清播放和离线下载
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}